/* =============================================================================
 * M.M.LaFleur — apply the welcome code to the cart after an email sign-up
 * (v4.7.9).
 *
 * OFF BY DEFAULT (Oct 22 2026). snippets/mm_cart_drawer.liquid only loads
 * this file when Theme settings > M.M.LaFleur > "Welcome code (NEWTOMM)" is
 * ticked, and prints those settings as <script id="mm-newtomm-config">. With
 * no config on the page the built-in default below is also off.
 *
 * Listens for:
 *   - Klaviyo onsite forms: window event "klaviyoForms", detail.type "submit"
 *     (detail.formId is the form id).
 *   - Alia popups: document event "alia:signup" (detail.popupID). The live
 *     theme has the Alia app embed on, and Alia is a popup app, so it may be
 *     the one actually running the welcome popup.
 *
 * On the first qualifying sign-up in the browser session it fetches
 * /discount/<CODE> (same origin, response ignored). Shopify sets the
 * discount_code cookie and attaches the code to the cart, then the drawer is
 * re-rendered through mm-cart.js (mm:cart:refresh), which shows
 * "NEWTOMM applied -$X" when the code is applicable. For a shopper the code
 * does not apply to (existing customer, no full-price items) Shopify returns
 * no discount application and the drawer simply shows no line.
 *
 * Guarded by sessionStorage (falls back to a page-level flag) so it runs once.
 * ========================================================================== */

(function () {
  "use strict";

  var DONE_KEY = "mm_newtomm_applied";
  var pageDone = false;

  /* Used only when no #mm-newtomm-config is on the page: stay off. */
  var DEFAULTS = { enable: false, code: "NEWTOMM", sources: "klaviyo_alia", formIds: "" };

  function config() {
    var node = document.getElementById("mm-newtomm-config");
    if (!node) return DEFAULTS;
    try { return JSON.parse(node.textContent || "{}"); } catch (err) { return DEFAULTS; }
  }

  function alreadyDone() {
    if (pageDone) return true;
    try { return window.sessionStorage.getItem(DONE_KEY) === "1"; } catch (err) { return false; }
  }

  function markDone() {
    pageDone = true;
    try { window.sessionStorage.setItem(DONE_KEY, "1"); } catch (err) { /* page flag still guards */ }
  }

  function allowedId(c, id) {
    var list = String(c.formIds || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    if (!list.length) return true;
    return list.indexOf(String(id == null ? "" : id)) !== -1;
  }

  function apply(source, id) {
    var c = config();
    if (!c || c.enable !== true) return;
    var code = String(c.code || "").trim();
    if (!code) return;
    var sources = String(c.sources || "klaviyo_alia");
    if (source === "klaviyo" && sources === "alia") return;
    if (source === "alia" && sources === "klaviyo") return;
    if (!allowedId(c, id)) return;
    if (alreadyDone()) return;
    markDone();

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "discount/" + encodeURIComponent(code), {
      credentials: "same-origin",
      redirect: "follow",
      headers: { Accept: "text/html" }
    })
      .catch(function () { /* network blip: the code can still be typed at checkout */ })
      .then(function () {
        if (window.MMCart && typeof window.MMCart.refresh === "function") {
          window.MMCart.refresh();
        } else {
          try { document.dispatchEvent(new CustomEvent("mm:cart:refresh")); } catch (err) { /* noop */ }
        }
        try {
          document.dispatchEvent(new CustomEvent("mm:newtomm:applied", { detail: { code: code, source: source, id: id } }));
        } catch (err) { /* noop */ }
      });
  }

  window.addEventListener("klaviyoForms", function (e) {
    var d = e && e.detail;
    if (!d || d.type !== "submit") return;
    apply("klaviyo", d.formId);
  });

  document.addEventListener("alia:signup", function (e) {
    var d = (e && e.detail) || {};
    apply("alia", d.popupID);
  });
}());
